module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/tankodrome-lvl2-50.a937a4fd.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/tankodrome-lvl2-50.png
// module id = 3556
// module chunks = 11